import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_2 = { class: "card-header d-flex align-items-center bg-white" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start" }
const _hoisted_4 = {
  key: 0,
  class: "badge bg-primary"
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "card-text mb-0 text-primary" }
const _hoisted_7 = {
  key: 0,
  class: "card-muted mt-0"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "card-muted mt-0"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 2,
  class: "card-muted mt-0"
}
const _hoisted_12 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_event_count_selector = _resolveComponent("event-count-selector")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.option.name), 1),
            (_ctx.option.pack)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Pack de " + _toDisplayString(_ctx.option.pack.quantity) + " tickets", 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_event_count_selector, {
            id: _ctx.option.id,
            max: _ctx.max,
            min: _ctx.min,
            class: "ms-auto",
            onOnChange: _ctx._changeSelector,
            sales_started: _ctx.sales_started,
            sales_ended: _ctx.sales_ended,
            disabled: _ctx.disabled
          }, null, 8, ["id", "max", "min", "onOnChange", "sales_started", "sales_ended", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.format_currency(_ctx.option.price)), 1),
          ((!_ctx.option.ticket_sales_starts || _ctx.sales_started) && !_ctx.sales_ended)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createElementVNode("small", null, [
                  _cache[0] || (_cache[0] = _createTextVNode(" Las ventas finalizan el día ", -1)),
                  (typeof _ctx.sales_ends != 'boolean')
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_8, _toDisplayString(_ctx.sales_ends.format("DD MMMM, YYYY • hh:mm a")), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.option.ticket_sales_starts && !_ctx.sales_started && !_ctx.sales_ended)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                _createElementVNode("small", null, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Las ventas comienzan el día ", -1)),
                  (_ctx.option.ticket_sales_starts.type != 'immediately')
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_10, _toDisplayString(_ctx.sales_starts.format("DD MMMM, YYYY • hh:mm a")), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.sales_ended)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("small", null, "Las ventas han finalizado", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_ctx.option.description)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.option.description), 1))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}